import { MachineOfflineService } from '~/sqlite/services/machine';

export class MachineLocalDataSource extends MachineOfflineService {}

export const machineLocal = new MachineLocalDataSource();
